import styled from "styled-components";

export const SubTitle = styled.h2`
  font-weight: 500;
  margin-bottom: 5px;

  @media (max-width: 760px) {
    font-size: 1.5rem;
  }
`;

export const Badge = styled.span`
  color: ${({ color }) => color ? color : 'var(--white)'};
  font-size: ${({ size }) => size ? size : '0.8rem'};
  font-weight: 700;
  height: min-content;
  width: min-content;
  background-color: ${({ bgColor }) => `var(${bgColor})`};
  border-radius: ${({ circle }) => circle ? '50%' : '2px'};
  text-transform: ${({ transform }) => transform ? transform : 'uppercase'};
  padding: 1px 5px;

  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
`;

export const DaysAgo = styled.small`
  color: ${({ color }) => color ? color : 'var(--gray)'};
  font-size: ${({ size = '0.8rem' }) => size };
  font-style: ${({ fontStyle = 'italic' }) => fontStyle };
`;

